import {
  LOGOUT,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  PROFILE_UPDATED_ERROR,
  UPDATE_PROFILE,
  UPDATE_PASSWORD,
  PASSWORD_UPDATED_ERROR,
  PASSWORD_UPDATED,
  REQUEST_API_KEY,
  REQUEST_API_KEY_SUCCEED,
  REQUEST_API_KEY_ERROR,
  SET_LOADING,
  TOGGLE_MEMBER,
  TOGGLE_MEMBER_SUCCEED,
  TOGGLE_MEMBER_ERROR,
  ADD_MEMBER,
  ADD_MEMBER_SUCCEED,
  ADD_MEMBER_ERROR,
  UPDATE_MEMBER,
  UPDATE_MEMBER_SUCCEED,
  UPDATE_MEMBER_ERROR,
  UPLOAD_LOGO,
  UPLOAD_LOGO_SUCCEED,
  UPLOAD_LOGO_ERROR,
} from './constants';
import {AGENT_MEMBERS_LOADED, GET_AGENT_MEMBERS} from "../Profile/constants";

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function getUser() {
  return {
    type: LOAD_USER,
  };
}

export function setUser(user) {
  return {
    type: LOAD_USER_SUCCESS,
    user,
  };
}

export function loginError() {
  return {
    type: LOAD_USER_ERROR,
  };
}

export function profileUpdatedError(errors) {
  return {
    type: PROFILE_UPDATED_ERROR,
    errors,
  };
}

export function sendUpdateProfile(profile) {
  return {
    type: UPDATE_PROFILE,
    profile,
  };
}

export function sendUpdatePassword(passwords) {
  return {
    type: UPDATE_PASSWORD,
    passwords,
  };
}

export function sendRequestApiKey() {
  return {
    type: REQUEST_API_KEY,
  };
}

export function apiKeyReceived(apiKey) {
  return {
    type: REQUEST_API_KEY_SUCCEED,
    apiKey,
  };
}

export function apiKeyFailed(errors) {
  return {
    type: REQUEST_API_KEY_ERROR,
    errors,
  };
}

export function toggleMember(agentId) {
  return {
    type: TOGGLE_MEMBER,
    agentId,
  };
}

export function toggleMemberSuccess(agent) {
  return {
    type: TOGGLE_MEMBER_SUCCEED,
    agent,
  };
}

export function toggleMemberFailed(errors) {
  return {
    type: TOGGLE_MEMBER_ERROR,
    errors,
  };
}

export function addMember(agent) {
  return {
    type: ADD_MEMBER,
    agent,
  };
}

export function addMemberSuccess(agent) {
  return {
    type: ADD_MEMBER_SUCCEED,
    agent,
  };
}

export function addMemberFailed(errors) {
  return {
    type: ADD_MEMBER_ERROR,
    errors,
  };
}

export function updateMember(agent) {
  return {
    type: UPDATE_MEMBER,
    agent,
  };
}

export function updateMemberSuccess(agent) {
  return {
    type: UPDATE_MEMBER_SUCCEED,
    agent,
  };
}

export function updateMemberFailed(errors) {
  return {
    type: UPDATE_MEMBER_ERROR,
    errors,
  };
}

export function uploadLogo(file) {
  return {
    type: UPLOAD_LOGO,
    file,
  };
}

export function uploadLogoSuccess(user) {
  return {
    type: UPLOAD_LOGO_SUCCEED,
    user,
  };
}

export function uploadLogoFailed(errors) {
  return {
    type: UPLOAD_LOGO_ERROR,
    errors,
  };
}

export function passwordUpdated() {
  return {
    type: PASSWORD_UPDATED,
  };
}

export function passwordUpdatedError(errors) {
  return {
    type: PASSWORD_UPDATED_ERROR,
    errors,
  };
}

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading,
  };
}

export function getMembers() {
  return {
    type: GET_AGENT_MEMBERS,
  };
}

export function loadedMembers(members) {
  return {
    type: AGENT_MEMBERS_LOADED,
    members,
  };
}
